import React from 'react';

import {Label, Select, Input, Textarea} from 'Components/Form';
import { User } from "Services";

/*
Example...
<TravelDetails
    value={form.travel_details}
    error={getFieldError('travel_details')}
    onChange={(v) => handleInput('travel_details', v)}
/>
*/

export default class TravelDetails extends React.Component {
    /**
     * @var options
     * @type {array}
     */
    options = [
        {
            label: 'Train',
            value: 'Train'
        },
        {
            label: 'Hire Car',
            value: 'Hire Car'
        },
        {
            label: 'Own Car',
            value: 'Own Car'
        },
        {
            label: 'Plane',
            value: 'Plane'
        },
        {
            label: 'Other',
            value: 'Other'
        }
    ];

    /**
     * @method handleChange
     * @param {string} key
     * @param {string} v
     */
    handleChange = (key, v) =>  {
        const {value, onChange} = this.props;

        onChange({
            ...value,
            [key]: v
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            value,
            error,
            me
        } = this.props;

        return (
            <div className='flex flex-col gap-4'>
                <p className="font-bold">
                    Travel Information
                </p>

                {error &&
                    <Label
                        label=""
                        error={error}
                    />
                }
                { ['Support Office'].includes(User.data.first_group_name) &&
                    <p className={"font-light mb-4"}>
                        Please organise your own travel using Concur,
                        if travelling by train or needing to hire a car.
                    </p>
                }
                <Select
                    label={me ?
                        "Please confirm how you will be travelling to the event?" :
                        "Please confirm how the individual will be travelling to the event?"
                    }
                    value={value?.travel}
                    onChange={(v) => this.handleChange('travel', v)}
                    options={(me) ? this.options.filter((e) => e.label !== 'Same as Store / Deputy Manager') : this.options}
                />

                {value?.travel === 'Train' &&
                    <>
                        <Input
                            label="Departure station"
                            value={value?.departure_station}
                            onChange={(v) => this.handleChange('departure_station', v)}
                        />

                        <Input
                            label="Time of train"
                            value={value?.time_of_train}
                            onChange={(v) => this.handleChange('time_of_train', v)}
                        />

                        <Input
                            label="Return station"
                            value={value?.return_station}
                            onChange={(v) => this.handleChange('return_station', v)}
                        />
                    </>
                }

                {value?.travel === 'Plane' &&
                    <>
                        <Input
                            label="Departure airport"
                            value={value?.departure_airport}
                            onChange={(v) => this.handleChange('departure_airport', v)}
                        />

                        <Input
                            label="Arrival airport and flight arrival time"
                            value={value?.flight_time}
                            onChange={(v) => this.handleChange('flight_time', v)}
                        />

                        <Input
                            label="Name as on passport"
                            value={value?.name_as_on_passport}
                            onChange={(v) => this.handleChange('name_as_on_passport', v)}
                        />
                    </>
                }

                {value?.travel === 'Other' &&
                    <Textarea
                        label="Specify"
                        value={value?.specify}
                        onChange={(v) => this.handleChange('specify', v)}
                    />
                }
            </div>
        );
    }
}
